
<div class="card d-none">
  <h2>Audit Logs</h2>

  <!-- Filters -->
  <div class="filters">
    <input type="text" placeholder="Filter by Entity" [(ngModel)]="filters.entity">
    <input type="text" placeholder="Filter by User" [(ngModel)]="filters.user">
    <button (click)="loadAuditLogs()">Apply Filters</button>
  </div>

  <!-- AG Grid Table -->
  <ag-grid-angular class="ag-theme-alpine" style="width: 100%; height: 500px;" [rowData]="auditLogs"
    [columnDefs]="columnDefs" [pagination]="true" [defaultColDef]="defaultColDef" >	
  </ag-grid-angular>
</div>




<div class="container-fluid py-4">
  <!-- Page Title & Actions -->
  <div class="row mb-3">
    <div class="col-md-6">
      <h2 class="text-primary"><i class="bi bi-clock-history"></i> Audit Logs</h2>
    </div>
    <div class="col-md-6 text-md-end">
      <button class="btn btn-outline-primary" (click)="loadAuditLogs()">
        <i class="bi bi-arrow-clockwise"></i> Refresh Logs
      </button>
    </div>
  </div>

  <!-- Audit Log Table -->
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"><i class="bi bi-list-task"></i> Audit Log Entries</h5>
        </div>
        <div class="card-body p-2">
          <ag-grid-angular
            class="ag-theme-alpine"
            style="width: 100%; height: 600px;"
            [pagination]="true"
            [rowData]="auditLogs"
            [columnDefs]="columnDefs">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>
